var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view check-rule" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "div",
            {
              staticClass: "section operations",
              staticStyle: { height: "39px" }
            },
            [
              _c("div", { staticClass: "triggers" }, [
                _c(
                  "div",
                  [
                    _vm.currOptStatus === _vm.optStatusDef.normal
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.showAdd }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Add")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.showEdit }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Edit")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: { click: _vm.toDel }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.refresh }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.Refresh"))
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.editCheckRuleSetting }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Tool.VerificationSettings"))
                              )
                            ]
                          )
                        ]
                      : [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.save }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: { click: _vm.cancel }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
                          )
                        ]
                  ],
                  2
                )
              ])
            ]
          ),
          _c(
            "cargo-left-right-resize",
            {
              staticStyle: { "min-height": "100%" },
              attrs: {
                "left-style": {
                  display: "flex",
                  flexDirection: "column",
                  width: "25%"
                },
                "right-style": {
                  display: "flex",
                  flexDirection: "column",
                  width: "75%"
                }
              }
            },
            [
              _c(
                "template",
                { slot: "left" },
                [
                  _c("el-card", { staticClass: "box-card left-rules" }, [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("SystemMaintenance.ValidationRules"))
                        )
                      ])
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "grid-wrapper",
                        class: _vm.isEdit ? "isEdit" : "",
                        attrs: { loading: _vm.loading }
                      },
                      [
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isEdit,
                              expression: "isEdit"
                            }
                          ],
                          staticClass: "pure-loading-mask"
                        }),
                        _c("cargo-ag-grid", {
                          attrs: {
                            "show-side-bar": false,
                            "grid-options": _vm.checkRuleGrid.gridOptions,
                            "column-defs": _vm.checkRuleGrid.columnDefs,
                            "row-data": _vm.checkRuleGrid.rowData
                          }
                        })
                      ],
                      1
                    ),
                    _vm.isEdit
                      ? _c(
                          "div",
                          { staticClass: "app-main-inner-row" },
                          [
                            _c(
                              "el-form",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "label-position": "left",
                                  "label-width": "90px"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.RuleName"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: !_vm.isEdit },
                                      model: {
                                        value: _vm.oneCheckRule.ruleName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.oneCheckRule,
                                            "ruleName",
                                            $$v
                                          )
                                        },
                                        expression: "oneCheckRule.ruleName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.ValidationNode"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          disabled: !_vm.isEdit,
                                          filterable: ""
                                        },
                                        on: { change: _vm.onCheckNodeChange },
                                        model: {
                                          value: _vm.oneCheckRule.checkNode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.oneCheckRule,
                                              "checkNode",
                                              $$v
                                            )
                                          },
                                          expression: "oneCheckRule.checkNode"
                                        }
                                      },
                                      _vm._l(_vm.checkNodes, function(item) {
                                        return _c("el-option", {
                                          key: item.code,
                                          attrs: {
                                            label: item.chineseName,
                                            value: item.code
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.ValidationType"
                                      )
                                    }
                                  },
                                  [
                                    _vm.oneCheckRule.checkNode ===
                                      _vm.CheckRuleConstants
                                        .NODE_INVOICE_CONFIRM_OR_RECEPT.code ||
                                    _vm.oneCheckRule.checkNode ===
                                      _vm.CheckRuleConstants.NODE_SAVE_INVOICE
                                        .code
                                      ? _c(
                                          "el-select",
                                          {
                                            attrs: { disabled: !_vm.isEdit },
                                            model: {
                                              value:
                                                _vm.oneCheckRule.checkCategory,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.oneCheckRule,
                                                  "checkCategory",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "oneCheckRule.checkCategory"
                                            }
                                          },
                                          _vm._l(
                                            _vm.checkLogicCriterias,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.code,
                                                attrs: {
                                                  label: item.chineseName,
                                                  value: item.code
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.oneCheckRule.checkNode !==
                                      _vm.CheckRuleConstants
                                        .NODE_INVOICE_CONFIRM_OR_RECEPT.code &&
                                    _vm.oneCheckRule.checkNode !==
                                      _vm.CheckRuleConstants.NODE_SAVE_INVOICE
                                        .code
                                      ? _c(
                                          "el-select",
                                          {
                                            attrs: { disabled: !_vm.isEdit },
                                            model: {
                                              value:
                                                _vm.oneCheckRule.checkCategory,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.oneCheckRule,
                                                  "checkCategory",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "oneCheckRule.checkCategory"
                                            }
                                          },
                                          _vm._l(_vm.checkCriterias, function(
                                            item
                                          ) {
                                            return _c("el-option", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.filterCheckCriteria(
                                                    _vm.oneCheckRule.checkNode,
                                                    item.code
                                                  ),
                                                  expression:
                                                    "filterCheckCriteria(oneCheckRule.checkNode, item.code)"
                                                }
                                              ],
                                              key: item.code,
                                              attrs: {
                                                label: item.chineseName,
                                                value: item.code
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.ValidationMode"
                                      )
                                    }
                                  },
                                  [
                                    _vm.oneCheckRule.checkNode ===
                                      _vm.CheckRuleConstants
                                        .NODE_INVOICE_CONFIRM_OR_RECEPT.code ||
                                    _vm.oneCheckRule.checkNode ===
                                      _vm.CheckRuleConstants.NODE_SAVE_INVOICE
                                        .code
                                      ? _c(
                                          "el-select",
                                          {
                                            attrs: { disabled: !_vm.isEdit },
                                            model: {
                                              value: _vm.oneCheckRule.checkMode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.oneCheckRule,
                                                  "checkMode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "oneCheckRule.checkMode"
                                            }
                                          },
                                          _vm._l(_vm.checkErrorModes, function(
                                            item
                                          ) {
                                            return _c("el-option", {
                                              key: item.code,
                                              attrs: {
                                                label: item.chineseName,
                                                value: item.code
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.oneCheckRule.checkNode !==
                                      _vm.CheckRuleConstants
                                        .NODE_INVOICE_CONFIRM_OR_RECEPT.code &&
                                    _vm.oneCheckRule.checkNode !==
                                      _vm.CheckRuleConstants.NODE_SAVE_INVOICE
                                        .code
                                      ? _c(
                                          "el-select",
                                          {
                                            attrs: { disabled: !_vm.isEdit },
                                            model: {
                                              value: _vm.oneCheckRule.checkMode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.oneCheckRule,
                                                  "checkMode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "oneCheckRule.checkMode"
                                            }
                                          },
                                          _vm._l(_vm.checkModes, function(
                                            item
                                          ) {
                                            return _c("el-option", {
                                              key: item.code,
                                              attrs: {
                                                label: item.chineseName,
                                                value: item.code
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.oneCheckRule.checkMode === 3,
                                        expression: "oneCheckRule.checkMode===3"
                                      }
                                    ],
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.EmailAddress"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: !_vm.isEdit },
                                      model: {
                                        value: _vm.oneCheckRule.remarks,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.oneCheckRule,
                                            "remarks",
                                            $$v
                                          )
                                        },
                                        expression: "oneCheckRule.remarks"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "form-tip" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SystemMaintenance.AllowOperationAfterValidationFails"
                                          )
                                        )
                                      )
                                    ]),
                                    _c(
                                      "el-radio-group",
                                      {
                                        attrs: { disabled: !_vm.isEdit },
                                        model: {
                                          value: _vm.oneCheckRule.continueCheck,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.oneCheckRule,
                                              "continueCheck",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "oneCheckRule.continueCheck"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: true } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("SystemMaintenance.Yes")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: false } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("SystemMaintenance.No")
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm.hqChecked
                                  ? _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { "margin-top": "20px" },
                                        attrs: { "label-width": "10px" }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.CheckRuleToAllBranch"
                                              )
                                            )
                                          )
                                        ]),
                                        _c("el-checkbox", {
                                          staticStyle: {
                                            "margin-left": "20px"
                                          },
                                          attrs: { no: "useHQ" },
                                          model: {
                                            value: _vm.oneCheckRule.useHQ,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneCheckRule,
                                                "useHQ",
                                                $$v
                                              )
                                            },
                                            expression: "oneCheckRule.useHQ"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.hqChecked
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: _vm.showBranchSelectDialog
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.SetExclusionOffices"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.hqChecked
                                  ? _c("el-input", {
                                      attrs: { disabled: true },
                                      model: {
                                        value:
                                          _vm.branchSelectDialog
                                            .showExclusionOfficeIds,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.branchSelectDialog,
                                            "showExclusionOfficeIds",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "branchSelectDialog.showExclusionOfficeIds"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _c("branch-select-dialog", {
                    attrs: {
                      visible: _vm.branchSelectDialog.visible,
                      "office-list": _vm.branchSelectDialog.officeList,
                      value: _vm.branchSelectDialog.value
                    },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(
                          _vm.branchSelectDialog,
                          "visible",
                          $event
                        )
                      },
                      callback: _vm.branchSelectDialog.callback
                    }
                  })
                ],
                1
              ),
              _c(
                "template",
                { slot: "right" },
                [
                  _c(
                    "cargo-left-right-resize",
                    {
                      staticStyle: { height: "100%", "min-height": "300px" },
                      attrs: {
                        "left-style": {
                          display: "flex",
                          flexDirection: "column",
                          width: "30%"
                        },
                        "right-style": {
                          display: "flex",
                          flexDirection: "column",
                          width: "70%"
                        }
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "left" },
                        [
                          _c("el-card", { staticClass: "box-card company" }, [
                            _c(
                              "div",
                              { attrs: { slot: "header" }, slot: "header" },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("SystemMaintenance.Company"))
                                  )
                                ])
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "section grid-wrapper" },
                              [
                                _c("cargo-ag-grid", {
                                  attrs: {
                                    disabled: true,
                                    "show-side-bar": false,
                                    "grid-options": _vm.officeGrid.gridOptions,
                                    "column-defs": _vm.officeGrid.columnDefs,
                                    "row-data": _vm.officeRowData
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { staticClass: "check-rule-right", slot: "right" },
                        [
                          _c(
                            "cargo-up-down-resize",
                            {
                              staticStyle: {
                                height: "100%",
                                "flex-direction": "column"
                              },
                              attrs: {
                                "up-style": {
                                  display: "flex",
                                  flexDirection: "column",
                                  paddingBottom: "5px"
                                },
                                "down-style": {
                                  display: "flex",
                                  flexDirection: "column",
                                  paddingTop: "5px"
                                }
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "up" },
                                [
                                  _c("check-criteria", {
                                    ref: "checkCriteria",
                                    attrs: {
                                      disabled: true,
                                      "check-rule": _vm.oneCheckRule,
                                      "is-edit-check-rule":
                                        _vm.isEdit && _vm.checkboxSelection
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "template",
                                { slot: "down" },
                                [
                                  _c("check-expression", {
                                    ref: "checkExpression",
                                    attrs: {
                                      "check-rule": _vm.oneCheckRule,
                                      "is-edit-check-rule": _vm.isEdit
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.checkRuleSetDialog.visible,
            title: _vm.$t("Tool.VerificationSettings"),
            width: "522px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.checkRuleSetDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { "margin-top": "15px" },
              attrs: { "label-width": "100px" }
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "span",
                    {
                      staticClass: "blue",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.PopupMode")))]
                  ),
                  _c("el-checkbox", {
                    on: { change: _vm.onPopupModeChange },
                    model: {
                      value: _vm.checkRuleSetDialog.form.popupMode,
                      callback: function($$v) {
                        _vm.$set(_vm.checkRuleSetDialog.form, "popupMode", $$v)
                      },
                      expression: "checkRuleSetDialog.form.popupMode"
                    }
                  }),
                  _c("span", { staticStyle: { "margin-left": "2px" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("SystemMaintenance.DisplayWhenThereIsValidation")
                      )
                    )
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("SystemMaintenance.ValidationNode") }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "350px" },
                    attrs: {
                      disabled: !_vm.checkRuleSetDialog.form.popupMode,
                      filterable: "",
                      multiple: true,
                      "static-options": _vm.checkNodes,
                      "default-multiple-value": _vm.toNumArray(
                        _vm.checkRuleSetDialog.form.multiCheckNode
                      ),
                      "tag-name": "chineseName",
                      "tag-value": "code",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.checkRuleSetDialog.form.multiCheckNode = _vm.toTxt(
                          p.value
                        )
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("SystemMaintenance.ValidationMode") }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "350px" },
                    attrs: {
                      disabled: !_vm.checkRuleSetDialog.form.popupMode,
                      filterable: "",
                      multiple: true,
                      "static-options": _vm.checkModes,
                      "default-multiple-value": _vm.toNumArray(
                        _vm.checkRuleSetDialog.form.multiCheckMode
                      ),
                      "tag-name": "chineseName",
                      "tag-value": "code",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.checkRuleSetDialog.form.multiCheckMode = _vm.toTxt(
                          p.value
                        )
                      }
                    }
                  })
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: " " } }, [
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c("i", {
                    staticClass: "el-icon-warning",
                    staticStyle: { color: "#E6A23C", "line-height": "28px" }
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "white-space": "nowrap",
                        overflow: "hidden",
                        "text-overflow": "ellipsis",
                        "margin-left": "5px"
                      },
                      attrs: {
                        title: _vm.$t("SystemMaintenance.TheBeAppliedToOffices")
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SystemMaintenance.TheBeAppliedToOffices")
                        )
                      )
                    ]
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onSaveCheckRuleSet }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Confirm2")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.checkRuleSetDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }